import React, { Component } from "react"
import './BlogPost.less';
import ExternalContent from '../components/ExternalContent'
import {graphql} from "gatsby";
import Wrapper from '../components/Wrapper.js';
import GoBack from '../components/GoBack';
import Img from "gatsby-image";
import {Col, Row, Button} from "antd";
import Link from "../components/Link";
import {Icon} from "react-fa";

const ButtonGroup = Button.Group;

class BlogPost extends Component {
    render() {
        let modules = buildPostModules(this.props.data.wordpressPost.acf.content_post);
        const post = this.props.data.wordpressPost;
        const acfFields = post.acf;

        // Create any structured data required
        let image = '';
        if(post.acf.image) image = post.acf.image.localFile.childImageSharp.original.src;
        let schema = [{
            "@context": "http://schema.org/",
            "@type": "Article",
            name: post.title,
            headline: post.title,
            description: post.acf.excerpt,
            image: "https://www.wearebrew.co.uk" + image,
            datePublished: post.date,
            dateModified: post.modified,
            url: `https://www.wearebrew.co.uk/blog/${post.slug}/`,
            author: post.acf.team_member.post_title,
            publisher: {
                "@type": "Organization",
                name: "Brew Digital",
                logo: "https://www.wearebrew.co.uk/logo.png",
                url: "https://www.wearebrew.co.uk"
            },
        }];

        return (
            <Wrapper
                title={post.acf.meta_title || post.title}
                description={post.acf.meta_description}
                og_title={acfFields.og_title || post.acf.meta_title || post.title}
                og_description={acfFields.og_description || post.acf.meta_description}
                og_image={acfFields.og_image ? acfFields.og_image.localFile.childImageSharp.original.src : post.acf.image.localFile.childImageSharp.original.src}
                twitter_card_type={acfFields.twitter_card_type}
                twitter_title={acfFields.twitter_title}
                twitter_description={acfFields.twitter_description}
                twitter_image={acfFields.twitter_image ? acfFields.twitter_image.localFile.childImageSharp.original.src : post.acf.image.localFile.childImageSharp.original.src}
                schema={schema}
                path={`/blog/${post.slug}/`}
            >
                <span className="blog-back">
                    <GoBack />
                </span>
                { post.acf.image !== null ? <Img  style={{height: 490}} fluid={post.acf.image.localFile.childImageSharp.fluid} /> : null }
                <div className="blog-meta">
                    <Row>
                        <p className="reading-time">{post.acf.reading_time}</p>
                        <p className="tags">
                            {post.tags ? post.tags.map((tag) => {
                                return (
                                    <span className="tag">{tag.name}</span>
                                )
                            }) : null }
                        </p>
                        <h1>{post.title}</h1>
                        <p className="author"><span>Author </span><Link to={'/who-we-are/'+post.acf.team_member.post_name} >{post.acf.team_member.post_title}</Link></p>
                        <p className="date"><span>Date </span>{post.humanDate}</p>
                    </Row>
                </div>
                <Row className="module_standard_content blog_page">
                    <Col xs={{span: 24}} md={{span: 20, offset: 2}} lg={{span: 16, offset: 4}}>
                        {modules.map((module) => {
                            return module;
                        })}

                        <h3>Share this post</h3>
                        <ButtonGroup>
                            <Button type="primary">
                                <a href={"https://www.linkedin.com/shareArticle?mini=true&amp;url=" + this.props.location.href + "&amp;title=" + post.title + " - We Are Brew&amp;summary="} title="Share on LinkedIn" target="_blank" rel="noopener noreferrer">
                                    <Icon name="linkedin" />
                                </a>
                            </Button>
                            <Button type="primary">
                                <a href={"https://www.facebook.com/sharer/sharer.php?u=" + this.props.location.href} title="Share on Facebook" target="_blank" rel="noopener noreferrer">
                                    <Icon name="facebook" />
                                </a>
                            </Button>
                            <Button type="primary">
                                <a href={"https://twitter.com/intent/tweet?text=" + post.title + " - We Are Brew " + this.props.location.href} title="Share on Twitter" target="_blank" rel="noopener noreferrer">
                                    <Icon name="twitter" />
                                </a>
                            </Button>
                            <Button type="primary">
                                <a href={"whatsapp://send?text=" + this.props.location.href} title="Share on Whatsapp" target="_blank" rel="noopener noreferrer">
                                    <Icon name="whatsapp" />
                                </a>
                            </Button>
                            <Button type="primary">
                                <a href={"mailto:?subject=" + post.title + " - We Are Brew&amp;body=We%20Are%20Brew%20" + this.props.location.href} title="Share via Email">
                                    <Icon name="envelope" />
                                </a>
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </Wrapper>
        )
    }
}

function buildPostModules (modules){
    let response = [];
    for (let module in modules){

        const moduleType = modules[module].__typename;
        let content = '';

        switch (moduleType){

            case 'WordPressAcf_full_text':
                content = <ExternalContent key={modules[module].id}><div dangerouslySetInnerHTML={{__html: modules[module].text }} /></ExternalContent>
            break;

            case 'WordPressAcf_full_image':
                if (modules[module].image) {
                    // Check for a GIF or SVG and serve the file directly
                    let image = null;
                    const mimeType = modules[module].image.mime_type;
                    if (mimeType === 'image/gif' || mimeType === 'image/svg') {
                        image = modules[module].image.localFile.publicURL;
                    } else {
                        image = modules[module].image.localFile.childImageSharp.original.src;
                    }
                    content = <img key={modules[module].id} className="image-full" src={image} alt="" />
                }
            break;

            case 'WordPressAcf_image_text':
                if (modules[module].image) {
                    let image = null;
                    const mimeType = modules[module].image.mime_type;
                    if (mimeType === 'image/gif' || mimeType === 'image/svg') {
                        image = modules[module].image.localFile.publicURL;
                    } else {
                        image = modules[module].image.localFile.childImageSharp.original.src;
                    }
                    content = <ExternalContent key={modules[module].id}>
                        <img className={modules[module].image_side}
                             src={image} alt=""/>
                        <div dangerouslySetInnerHTML={{__html: modules[module].text}}/>
                    </ExternalContent>
                }
            break;

            case 'WordPressAcf_cta_block':
                content = <div className="cta-block" key={modules[module].id}>
                    <p>{modules[module].cta_desc_text}</p>
                    <Button type="primary">
                        <Link to={modules[module].cta_url}>{modules[module].cta_text}</Link>
                    </Button>
                </div>
            break;

            default:
                // Unknown module
                break;
        }
        if (content) response.push(content);
    }
    return response;
}

export const pageQuery = graphql`
  query($id: String!) {
    wordpressPost(id: { eq: $id }) {
      id
      slug
      title
      tags {
        name
      }
      date(formatString: "YYYY-MM-DDTHH:MM:SS")
      humanDate: date(formatString: "DD.MM.YYYY")
      modified(formatString: "YYYY-MM-DDTHH:MM:SS")
      acf {
        meta_title
        meta_description
		og_title
        og_description
        og_image {
          localFile {
            childImageSharp {
              original {
                width
                height
                src
              }
            }
          }  
        }
        twitter_title
        twitter_card_type
        twitter_description
        twitter_image {
          localFile {
            childImageSharp {
              original {
                width
                height
                src
              }
            }
          }  
        }  
        reading_time
        team_member {
          wordpress_id
          post_title
          post_name
        }
        excerpt
        image {
          localFile {
            childImageSharp {
              fluid(maxHeight: 620, quality: 90) {
                ... GatsbyImageSharpFluid
              }
              original {
                width
                height
                src
              }              
            }
          }
        }
		content_post {
          __typename
          ...on WordPressAcf_full_text {
            id
            text
          }
          ...on WordPressAcf_full_image {
            id
            image {
              mime_type
              localFile {
                publicURL
                childImageSharp {
                  original {
                    width
                    height
                    src
                  }
                  fluid(maxHeight: 450) {
                    ... GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
          ...on WordPressAcf_cta_block {
            id
            cta_desc_text
            cta_text
            cta_url
          }
          ...on WordPressAcf_image_text {
            id
            text
            image_side
            image {
              mime_type
              localFile {
                publicURL
                childImageSharp {
                  original {
                    width
                    height
                    src
                  }
                  fluid(maxHeight: 450) {
                    ... GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
          
        }
      }
    }
  }
`

export default BlogPost



